'use client';
import { useMembershipTokenStore } from '@/features/membership/shared/state/membership-token-store';
import { useUser } from '@/features/auth/shared/hooks/use-user';
import { useEffect } from 'react';
import { TokenBadge } from '@/features/membership/shared/components/token-menu-item/token-badge';
import { SkeletonTokenBadge } from '@/features/membership/shared/components/token-menu-item/token-badge-skeleton';

export const TokenMenuItem = () => {
  const { authenticatedUser } = useUser();
  const fetchTokens = useMembershipTokenStore((s) => s.fetchTokens);
  const tokensInitialized = useMembershipTokenStore((s) => s.initialized);
  const availableTokens = useMembershipTokenStore((s) => s.tokenSummary?.tokensAvailable ?? 0);

  const isWildMember = !!authenticatedUser?.isWildMember;

  useEffect(() => {
    if (isWildMember && !tokensInitialized) {
      fetchTokens();
    }
  }, [fetchTokens, isWildMember, tokensInitialized]);

  if (!isWildMember) return null;

  if (!tokensInitialized) return <SkeletonTokenBadge />;

  return <TokenBadge>{availableTokens}</TokenBadge>;
};
